import React from 'react';
import clsx from 'clsx';

import { SectionHeader } from '../../../components';

type QuizHeaderProps = {
  title: string;
  className?: string;
};

export const QuizHeader: React.FC<QuizHeaderProps> = ({ title, className }) => {
  return (
    <SectionHeader
      className={clsx('mt-md', className)}
      label={<h1 className="flex flex-row gap-x-md">{title}</h1>}
    />
  );
};
